import uuidv1 from 'uuid/v1';

import WorkoutScalingOption from './WorkoutScalingOption';

class Workout {
  constructor({
    _id = null,
    workoutType = null,
    workoutTypeModel = null,
    title = '',
    subtitles = [],
    description = '',
    transition = '',
    exercises = [],
    scaling = [],
    resultType = null,
  }) {
    this.key = uuidv1();
    this.id = _id;
    this.workoutType = workoutType;
    this.workoutTypeModel = workoutTypeModel;
    this.title = title;
    this.subtitles = subtitles;
    this.description = description;
    this.transition = transition;
    this.exercises = exercises;
    this.scaling = scaling.map(
      (scalingOption) => new WorkoutScalingOption(scalingOption)
    );
    this.resultType = resultType;
  }

  static assignWorkoutType(workout, workoutTypeInstance) {
    const { workoutTypeModel } = workoutTypeInstance;
    if (!['Benchmark', 'Exercise'].includes(workoutTypeModel)) {
      throw new Error(
        `Workout type model ${workoutTypeModel} is not supported`
      );
    }

    workout.key = uuidv1();
    workout.workoutType = workoutTypeInstance.id;
    workout.workoutTypeModel = workoutTypeModel;
    workout.title = workoutTypeInstance.title;
    workout.resultType = workoutTypeInstance.resultType;

    if (workoutTypeModel === 'Benchmark') {
      workout.subtitles = [...workoutTypeInstance.subtitles];
      workout.description = workoutTypeInstance.description;
      workout.exercises = [...workoutTypeInstance.exercises];
      workout.scaling = workoutTypeInstance.scaling.map(
        (scalingOption) => new WorkoutScalingOption(scalingOption)
      );
    } else if (workoutTypeModel === 'Exercise') {
      workout.subtitles = [workoutTypeInstance.subtitle];
      workout.description = '';
      workout.exercises = [workoutTypeInstance.exercise];
      workout.scaling = [];
    }

    return workout;
  }

  static assignDefaultWorkoutType(workout) {
    workout.key = uuidv1();
    workout.workoutType = null;
    workout.workoutTypeModel = null;
    workout.title = '';
    workout.resultType = null;
    workout.subtitles = ['']; // default subtitles
    workout.description = '';
    workout.exercises = ['']; // default exercises
    workout.scaling = []; // default scaling

    return workout;
  }
}

export default Workout;
